<template>
  <v-card class="mx-auto my-4" max-width="1000" :rounded="false" outlined>
    <v-toolbar color="blue-grey lighten-1" dark flat dense>
      <v-toolbar-title>{{ label }}</v-toolbar-title>
      <v-spacer v-if="!value" />
      <lean-create-linked-document-dialog v-if="!value && !disabled" :datatype="this.config.source" @afterSave="addRecordBySlug($event)" />
    </v-toolbar>
    <v-container fluid class="px-10 py-5">
      <v-list-item v-if="!!value" class="px-0">
        <lean-list-item-content v-if="record" @click="smallDialog = true" :listConfig="listConfig" :record="record" />
        <v-progress-circular v-else indeterminate color="blue-grey lighten-1" />
        <v-list-item-action>
          <div class="d-flex">
            <v-btn icon :href="`/data/${config.source}/${value}`" target="new">
              <v-icon color="grey lighten-1">mdi-pencil</v-icon>
            </v-btn>
            <lean-list-item-button
              v-if="!disabled"
              icon-name="mdi-link-variant-off"
              :tooltip="$t('tooltip.unlink')"
              @click="removeRecord"
            />
          </div>
        </v-list-item-action>
      </v-list-item>
      <lean-search-record v-else :config="config" :disabled="disabled" @change="addRecord($event)" />
    </v-container>
  </v-card>
</template>

<script>
import fieldMixin from '@/mixins/LeanField';
import { mapState, mapGetters } from 'vuex';
import LeanListItemContent from '../LeanListItemContent.vue';
import LeanListItemButton from '@/components/LeanListItemButton';
import LeanCreateLinkedDocumentDialog from '../LeanCreateLinkedDocumentDialog.vue';
import LeanSearchRecord from '../LeanSearchRecord.vue';

export default {
  components: { LeanListItemButton, LeanListItemContent, LeanCreateLinkedDocumentDialog, LeanSearchRecord },
  name: 'LeanLinkedDocument',
  mixins: [fieldMixin],
  data: () => ({
    record: null,
    loading: false,
    resultFieldLabel: 'slug',
    bounceSearch: null
  }),
  computed: {
    ...mapGetters(['workspaceBucket']),
    ...mapState({
      workspace: (state) => state.workspace,
      language: (state) => state.selectedLanguage
    }),
    searchLabel: {
      get() {
        return `Search for ${this.config.source}`;
      }
    },
    listConfig() {
      return this.datatypes[this.config.source].list || null;
    },
    slugList() {
      return this.items.map((entry) => {
        return entry.slug;
      });
    }
  },
  watch: {
    language: {
      async handler() {
        if (this.value?.slug) {
          await this.addRecordBySlug(this.value.slug);
        }
      }
    },
  },
  methods: {
    async querySelections(val) {
      this.loading = true;
      this.items = [
        ...((
          await this.$store.state.sdk.getDocuments({
            datatype: this.config.source,
            language: this.language,
            query: val
          })
        ).records || []),
        ...((
          await this.$store.state.sdk.getDocuments({
            datatype: this.config.source,
            language: this.language,
            filenames: [`data/${this.config.source}/${val}/${this.language}/index.json`]
          })
        ).records || [])
      ];
      this.loading = false;
    },
    async addRecord(record) {
      if(record?.slug) await this.addRecordBySlug(record.slug);
    },
    async addRecordBySlug(slug) {
      let dbRecord;
      await this.querySelections(slug);
      dbRecord = this.items.find((item) => item.slug === slug);
      if (!this.items.length) this.addRecordBySlug(slug);

      if (dbRecord) {
        this.record = dbRecord.resolved_data;
        this.value = dbRecord.slug;
      }
    },
    removeRecord() {
      this.value = null;
      this.record = null;
    },
  },
  async mounted() {
    if (typeof this.resolved === 'string') {
      await this.addRecordBySlug(this.resolved);
    } else {
      this.record = this.resolved;
    }
  }
};
</script>
